import { render, staticRenderFns } from "./matrix-statistics.vue?vue&type=template&id=b09203d6&scoped=true"
import script from "./matrix-statistics.vue?vue&type=script&lang=js"
export * from "./matrix-statistics.vue?vue&type=script&lang=js"
import style0 from "./matrix-statistics.vue?vue&type=style&index=0&id=b09203d6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b09203d6",
  null
  
)

export default component.exports